import { openBlock as t, createElementBlock as o, createElementVNode as r } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function l(s, e) {
  return t(), o("svg", n, [...e[0] || (e[0] = [
    r("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      d: "M6 7.5h12m0 0L14.5 4M18 7.5 14.5 11m3.5 5H6m0 0 3.5 3.5M6 16l3.5-3.5"
    }, null, -1)
  ])]);
}
const d = { render: l };
export {
  d as default,
  l as render
};
